import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  calculateAge,
  dateFormatter,
  dropdownFetch,
  getCurrentDateTime,
  getKeyPathValue,
  request,
  toast
} from '../../../../../utils';
import { AgeCalculator } from '../../../../../utils/AgeCalculator';
import { BASE_URL } from '../../../../../utils';
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { BANK_CASH, GENDER_DROPDOWN, RECEIPT_MODE, RELATION, TITLES, LAB_BOOKING_TYPE } from '../../../../../constants';
import { useLocation } from 'react-router-dom';
import { IPDSearchHandler } from '../../HMS/transactions/utils';
import { LabBillingDetailform } from './LabBillingDetailform';
import { CustomButtonn } from '../../../../../components';

const TABLE_HEADER = [
  {
    header: 'Bill No',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.bill_no}`}
        </span>
      );
    }
  },
  {
    header: 'Bill Date',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'UHID No',
    accessor: 'uhid' || '-'
  },
  {
    header: 'Patient Name',
    accessor: (row) => `${row.patient_name}`
  },
  {
    header: 'Sponsor',
    accessor: (row) => row?.sponsorDetails?.[0]?.name || '-'
  },
  {
    header: 'Mobile No',
    accessor: 'mobile'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const BILL_TABLE_HEADER = [
  {
    header: 'Test Name',
    accessor: (row) => row?.serviceName || row?.test_name?.test_name || row?.service.test_name || '-'
  },
  {
    header: 'Qty',
    accessor: 'quantity'
  },
  {
    header: 'Rate',
    accessor: 'rate'
  },
  {
    header: 'Amount',
    accessor: 'amount'
  },
  {
    header: 'Dis. Amt.',
    accessor: 'disc_amt'
  },
  {
    header: 'Net Amt',
    accessor: 'net_amt'
  },
];

const PATIENT_TABLE_HEADER = [
  { header: 'UHID', accessor: 'uhid' },
  { header: 'Created At', accessor: 'createdAt' },
  { header: 'Patient Name', accessor: (row) => `${row.name_suffix || ''} ${row.first_name || ''} ${row.last_name || ''}`.trim() },
  { header: 'Mobile No', accessor: 'address.mobile' },
  { header: 'Doctor', accessor: 'consultant.name' },
  { header: 'Address', accessor: 'address.address' }
];

const OPD_BILLING_TABLE_HEADER = [
  { header: 'UHID', accessor: 'uhid' },
  { header: 'Created At', accessor: 'createdAt' },
  { header: 'Patient Name', accessor: (row) => `${row.patient?.name || '-'}` },
  { header: 'Mobile No', accessor: (row) => `${row.patient?.mobile_no || '-'}` },
  { header: 'Doctor', accessor: (row) => row.service_items?.[0]?.doctor || '-' }
];

const IPD_BILLING_TABLE_HEADER = [
  { header: 'UHID', accessor: (row) => row?.patient?.uhid || '-' },
  { header: 'Created At', accessor: 'createdAt' },
  { header: 'Patient Name', accessor: (row) => `${row.patient?.name || '-'}` },
  { header: 'Mobile No', accessor: (row) => `${row.patient?.mobile_no || '-'}` },
  { header: 'Doctor', accessor: (row) => row.service_items?.[0]?.doctor || '-' }
];

const DISCOUNT_TYPES = [
  { _id: 'amount', name: 'Amount' },
  { _id: 'percentage', name: 'Percentage' }
];

const initialInvestiagtionBookingDataObj = {
  data: [],
  loading: false
};

const initialOpdBillingDataObj = {
  data: [],
  loading: false
};

const initialIpdBillingDataObj = {
  data: [],
  loading: false
};

export const InvestigationBooking = () => {
  const doctorIDRef = useRef();
  const sponsorIdRef = useRef();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [addDetailsDialogOpen, setAddDetailsDialogOpen] = useState(false);
  const [IPDSearchDialogOpen, setIPDSearchDialogOpen] = useState(false);
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [investigationBookingDataObj, setInvestigationBookingDataObj] = useState(initialInvestiagtionBookingDataObj);
  const [opdBillingDataObj, setOpdBillingDataObj] = useState(initialOpdBillingDataObj);
  const [ipdBillingDataObj, setIpdBillingDataObj] = useState(initialIpdBillingDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
  const [patientDetailList, setPatientDetailList] = useState([]);
  const [guardianDropdown, setGuardianDropdown] = useState([]);
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const [referralDropdown, setReferralDropdown] = useState([]);
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [searchOpdBillingDialog, setSearchOpdBillingDialog] = useState(false);
  const [searchIpdBillingDialog, setSearchIpdBillingDialog] = useState(false);
  const [serviceDropdown, setSeriveDropdown] = useState([]);
  const [bookingId, setBookingId] = useState(null);
  const [originalOpdData, setOriginalOpdData] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));
  const netAmtRef = useRef(0);
  const [input, setInput] = useState('');
  const [opdInput, setOpdInput] = useState('');
  const [patientType, setPatientType] = useState('');
  const [editData, setEditData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingRowIndex, setEditingRowIndex] = useState(null);
  const [discountType, setDiscountType] = useState('amount');

  

  
    const isEnabledDate =
      user && user.permissions ? user.permissions.some((permission) => permission.includes('DatePermission')) : false;

  // Add mount check ref
  const isMounted = useRef(true);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        patient_name: Yup.string().required('Please Enter Patient Name'),
        age: Yup.string().required('Please Enter Age'),
        mobile: Yup.string()
          .required('Mobile number is required')
          .matches(/^\d{10}$/, 'Mobile number must be exactly 10 digits'),
        bill: Yup.object().shape({
          pay_mode: Yup.string().required('Payment mode is required')
        }),
        // Doctor is an object, so use mixed() or remove validation
        doctor: Yup.mixed().nullable()
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      patient_suffix: 'Mr.',
      gender: 'Male',
      age: '',
      age_in_days: 0,
      booking_mode: 'Lab',
      doctor: null, // Set to null since it's an object
      bill: {
        pay_mode: 'CASH',
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0,
        total_qty: 0,
        total_amt: 0,
        total_recpt: 0,
        balance_amt: 0
      },
      discountType: 'amount'
    },
    mode: 'all'
  });

  const { handleSubmit, watch, reset, setValue, getValues, formState } = methods;

  const discAmt = watch('bill.disc_amt');
  const netAmtWatch = watch('bill.net_amt');
  const recAmt1Watch = watch('bill.rec_amt_1');
  const recAmt2Watch = watch('bill.rec_amt_2');
  const payMode = watch('bill.pay_mode');
  const uhid = watch('uhid');
  const ipd_no = watch('ipd_no');
  const bookingModeWatch = watch('booking_mode');
  const sponsor = watch('sponsor');

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Calculate totals from detail list
  useEffect(() => {
    if (!isMounted.current) return;

    let total_qty = 0;
    let total_amt = 0;
    let gst_amt = 0;
    let net_amt = 0;

    if (detailList && detailList.length > 0) {
      detailList.forEach((detail) => {
        total_qty += Number(detail.quantity) || 0;
        total_amt += Number(detail.amount) || 0;
        gst_amt += Number(detail.gst_amt) || 0;
        net_amt += Number(detail.net_amt) || 0;
      });
    }

    setValue('bill.total_qty', total_qty);
    setValue('bill.total_amt', total_amt);
    setValue('bill.gst_amt', gst_amt);
    setValue('bill.net_amt', net_amt);
    netAmtRef.current = net_amt;
  }, [detailList, setValue]);

  // Handle discount changes
  useEffect(() => {
    if (!isMounted.current) return;

    const currentNetAmt = netAmtRef.current;
    const discountAmount = Number(discAmt) || 0;

    if (currentNetAmt > 0) {
      let calculatedNetAmt = currentNetAmt;
      let calculatedDiscAmt = discountAmount;

      if (discountType === 'percentage') {
        // If percentage type, validate and calculate amount
        if (discountAmount > 0 && discountAmount <= 100) {
          calculatedDiscAmt = (currentNetAmt * discountAmount) / 100;
          calculatedNetAmt = Math.max(0, currentNetAmt - calculatedDiscAmt);
        } else if (discountAmount > 100) {
          // Auto-correct if percentage exceeds 100%
          calculatedDiscAmt = currentNetAmt;
          calculatedNetAmt = 0;
          setValue('bill.disc_amt', 100);
        }
      } else {
        // If amount type, validate amount doesn't exceed net amount
        if (discountAmount > currentNetAmt) {
          calculatedDiscAmt = currentNetAmt;
          calculatedNetAmt = 0;
          setValue('bill.disc_amt', currentNetAmt);
        } else {
          calculatedNetAmt = Math.max(0, currentNetAmt - discountAmount);
        }
      }

      setValue('bill.net_amt', calculatedNetAmt);
    }
  }, [discAmt, discountType, setValue]);

  // Handle payment mode and receipt calculations
  useEffect(() => {
    if (!isMounted.current) return;

    const netAmount = Number(netAmtWatch) || 0;
    const receipt1 = Number(recAmt1Watch) || 0;
    const receipt2 = Number(recAmt2Watch) || 0;

    let total_recpt = 0;
    let balanceAmt = 0;

    switch (payMode) {
      case 'CASH':
        setValue('bill.rec_amt_2', 0);

        // Validation for maximum receipt amount
        if (receipt1 > netAmount) {
          // Auto-correct if receipt amount exceeds net amount
          setValue('bill.rec_amt_1', netAmount);
          total_recpt = netAmount;
          balanceAmt = 0;
        } else {
          total_recpt = receipt1;
          balanceAmt = Math.max(0, netAmount - receipt1);
        }
        break;
      case 'Bank':
      case 'UPI':
      case 'Paytm':
      case 'RTGS/NEFT/Cheque':
      case 'Credit Card':
      case 'Debit Card':
        setValue('bill.rec_amt_1', 0);
        setValue('bill.rec_amt_2', netAmount);
        total_recpt = netAmount;
        balanceAmt = 0;
        break;
      case 'Credit':
        setValue('bill.rec_amt_1', 0);
        setValue('bill.rec_amt_2', 0);
        total_recpt = 0;
        balanceAmt = netAmount;
        break;
      default:
        total_recpt = receipt1 + receipt2;
        balanceAmt = Math.max(0, netAmount - total_recpt);
    }

    setValue('bill.total_recpt', total_recpt);
    setValue('bill.balance_amt', balanceAmt);
  }, [netAmtWatch, recAmt1Watch, recAmt2Watch, payMode, setValue]);

  // Handle booking mode change
  const handleBookingModeChange = (mode) => {
    if (mode === 'Lab') {
      // Clear UHID and IPD fields for walk-in
      setValue('uhid', '');
      setValue('ipd_no', '');
      setPatientType('walkin');
      // Clear any auto-filled data
      setValue('patient_name', '');
      setValue('mobile', '');
      setValue('address', '');
      setValue('gender', 'Male');
      setValue('age', '');
      setValue('age_in_days', 0);
      setValue('doctor', '');
    } else if (mode === 'Opd') {
      setValue('ipd_no', '');
      setPatientType('OPD');
    } else if (mode === 'Ipd') {
      setValue('uhid', '');
      setPatientType('IPD');
    }
  };

  // Load selected record data
  useEffect(() => {
    if (!isMounted.current || !selectedRecord) return;

    try {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));

      setValue('uhid', selectedRecord.uhid || '');
      setValue('bill_no', selectedRecord?.bill_no || '');
      setValue('patient_suffix', selectedRecord.patient_suffix || 'Mr.');
      setValue('patient_name', selectedRecord.patient_name || '');
      setValue('mobile', selectedRecord.mobile || '');
      setValue('address', selectedRecord.address || '');
      setValue('ref_by', selectedRecord.ref_by?._id || selectedRecord.ref_by || '');
      setValue('sponsor', selectedRecord.sponsor?._id || selectedRecord.sponsor || '');
      setValue('doctor', selectedRecord.doctor?._id || selectedRecord.doctor || '');
      setValue('remarks', selectedRecord.remarks || '');
      setValue('guardian_type', selectedRecord.guardian_type || '');
      setValue('guardian_name', selectedRecord.guardian_name || '');
      setValue('age', selectedRecord.age || '');
      setValue('booking_mode', selectedRecord.booking_mode || 'Lab');

      const formattedbillDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
      setValue('date', formattedbillDate);
      setValue('time', selectedRecord?.billing_time || new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5));

      setDetailList(selectedRecord.service_items || []);
      setPatientType(selectedRecord.patient_type || 'walkin');
    } catch (error) {
      console.error('Error loading selected record:', error);
      toast('Error loading record data', { variant: 'error' });
    }
  }, [selectedRecord, setValue]);

  // Fetch service dropdown
  const getServiceDropdown = useCallback(async () => {
    if (!isMounted.current) return;

    try {
      const data = await dropdownFetch('lis-test');
      if (isMounted.current) {
        setSeriveDropdown(data || []);
      }
    } catch (error) {
      console.error('Failed to fetch services:', error);
      if (isMounted.current) {
        toast('Failed to load services', { variant: 'error' });
      }
    }
  }, []);

  useEffect(() => {
    getServiceDropdown();
  }, [getServiceDropdown]);

  // Form submission
  // Form submission
  const formSubmit = async (formValues) => {
    if (!isMounted.current) return;
    setLoading(true);

    try {
      if (detailList.length === 0) {
        toast('Please add at least one test first', { variant: 'warning' });
        return;
      }

      let finalDiscAmt = Number(formValues.bill.disc_amt) || 0;

      // Convert percentage to amount if needed
      if (discountType === 'percentage' && finalDiscAmt > 0 && finalDiscAmt <= 100) {
        finalDiscAmt = (netAmtRef.current * finalDiscAmt) / 100;
      }

      // Doctor validation for non-Lab modes
      if (formValues.booking_mode !== 'Lab' && !formValues.doctor) {
        toast('Doctor name is required for OPD/IPD patients', { variant: 'warning' });
        return;
      }

      // ✅ Clean empty string fields (convert to null)
      const cleanedValues = {
        ...formValues,
        sponsor: formValues.sponsor === '' ? null : formValues.sponsor,
        doctor: formValues.doctor === '' ? null : formValues.doctor,
        ref_by: formValues.ref_by === '' ? null : formValues.ref_by
      };

      // Create clean bill object with ONLY financial fields
      const cleanBill = {
        pay_mode: cleanedValues.bill.pay_mode,
        out_sourced: cleanedValues.bill.out_sourced,
        rec_amt_1: cleanedValues.bill.rec_amt_1,
        rec_amt_2: cleanedValues.bill.rec_amt_2,
        tds_amt: cleanedValues.bill.tds_amt,
        disc_amt: finalDiscAmt, // Use the calculated discount amount
        gst_amt: cleanedValues.bill.gst_amt,
        net_amt: cleanedValues.bill.net_amt,
        total_qty: cleanedValues.bill.total_qty,
        total_amt: cleanedValues.bill.total_amt,
        total_recpt: cleanedValues.bill.total_recpt,
        balance_amt: cleanedValues.bill.balance_amt,
        auth_code: cleanedValues.bill.auth_code
      };

      const payload = {
        // Patient details at root level
        date: cleanedValues.date,
        time: cleanedValues.time,
        patient_suffix: cleanedValues.patient_suffix,
        gender: cleanedValues.gender,
        age: cleanedValues.age,
        age_in_days: cleanedValues.age_in_days,
        booking_mode: cleanedValues.booking_mode,
        doctor: cleanedValues.doctor,
        uhid: cleanedValues.uhid || '',
        ipd_no: cleanedValues.ipd_no || '',
        sponsor: cleanedValues.sponsor,
        remarks: cleanedValues.remarks,
        patient_name: cleanedValues.patient_name,
        mobile: cleanedValues.mobile,
        guardian_type: cleanedValues.guardian_type,
        guardian_name: cleanedValues.guardian_name,
        address: cleanedValues.address,
        ref_by: cleanedValues.ref_by,

        // Bill details in separate bill object
        bill: cleanBill,

        // Other fields
        bookingId,
        service_items: detailList,
        createdBy: user?.name || 'System',
        updatedBy: selectedRecord && currentAction === 'edit' ? user?.name : '',
        organisation,
        patient_type: cleanedValues.booking_mode === 'Lab' ? 'walkin' :
          cleanedValues.booking_mode === 'Opd' ? 'opd' : 'ipd',
      };

      const isEdit = selectedRecord && currentAction === 'edit';
      const endpoint = isEdit ? '/investigation-booking-edit' : '/investigation-booking-create';
      const method = isEdit ? 'PUT' : 'POST';

      const response = await request(endpoint, {
        method,
        params: isEdit ? selectedRecord._id : null,
        body: payload
      });

      if (isMounted.current && response?.success) {
        toast(`Successfully ${isEdit ? 'edited' : 'created'} Investigation Booking`, { variant: 'success' });
        setSelectedRecord(response.data);

        if (!isEdit) {
          console.log("hello news")
          setDetailList([]);
          reset({
            date: new Date().toISOString().split('T')[0],
            time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
            patient_suffix: 'Mr.',
            gender: 'Male',
            age: '',
            age_in_days: 0,
            booking_mode: 'Lab',
            doctor: null,
            bill: {
              pay_mode: 'CASH',
              out_sourced: 'No',
              rec_amt_1: 0,
              rec_amt_2: 0,
              tds_amt: 0,
              disc_amt: 0,
              gst_amt: 0,
              net_amt: 0,
              total_qty: 0,
              total_amt: 0,
              total_recpt: 0,
              balance_amt: 0
            }
          });
          setDiscountType('amount');
          setPatientType('walkin');
        }

        setCurrentAction('');
      } else if (isMounted.current) {
        toast(`Failed to ${isEdit ? 'edit' : 'create'} Investigation Booking`, { variant: 'error' });
      }
    } catch (error) {
      console.error('Form submission error:', error);
      if (isMounted.current) {
        toast('Error submitting form', { variant: 'error' });
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };


  // Detail list handlers
  const handleRowDelete = (rowId) => {
    setDetailList((prev) => prev.filter((_, index) => index !== rowId));
  };

  const handleRowEdit = (row, index) => {
    setEditData(row);
    setEditingRowIndex(index);
    setIsEditMode(true);
    setAddDetailsDialogOpen(true);
  };

  const onDetailAddHandler = (data) => {
    if (!isMounted.current) return;

    try {
      if (isEditMode && editingRowIndex !== null) {
        // Update existing row
        const updatedDetailList = detailList.map((detail, index) =>
          index === editingRowIndex ? { ...detail, ...data } : detail
        );
        setDetailList(updatedDetailList);
        toast('Test updated successfully', { variant: 'success' });
      } else {
        // Add new row - check for duplicates
        const existingDetail = detailList.find(({ service }) => service === data.service);
        if (existingDetail) {
          toast('Test is already added', { variant: 'error' });
          return;
        }

        const serviceName = serviceDropdown.find(({ _id }) => _id === data.service)?.test_name;
        setDetailList((prev) => [
          ...prev,
          {
            ...data,
            service_name: serviceName || data.service_name || 'Unknown Service'
          }
        ]);
        toast('Test added successfully', { variant: 'success' });
      }
    } catch (error) {
      console.error('Error adding detail:', error);
      toast('Error adding test', { variant: 'error' });
    } finally {
      setEditingRowIndex(null);
      setIsEditMode(false);
      setEditData(null);
    }
  };

  // Record operations
  const handleCancelRecord = async () => {
    if (!selectedRecord || !isMounted.current) return;

    setLoading(true);
    try {
      const response = await request('/investigation-booking-cancel', {
        method: 'DELETE',
        params: selectedRecord._id
      });

      if (isMounted.current && response?.success) {
        toast('Successfully Cancelled Booking', { variant: 'success' });
        setSelectedRecord(null);
        reset();
      } else if (isMounted.current) {
        toast('Failed to cancel Booking', { variant: 'error' });
      }
    } catch (error) {
      console.error('Cancel error:', error);
      if (isMounted.current) {
        toast('Error cancelling booking', { variant: 'error' });
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  const handleDeleteRecord = async () => {
    if (!selectedRecord || !isMounted.current) return;

    setLoading(true);
    try {
      const response = await request('/investigation-booking-delete', {
        method: 'DELETE',
        params: selectedRecord._id
      });

      if (isMounted.current && response?.success) {
        toast('Successfully deleted Booking', { variant: 'success' });
        setSelectedRecord(null);
        reset();
      } else if (isMounted.current) {
        toast('Failed to delete Booking', { variant: 'error' });
      }
    } catch (error) {
      console.error('Delete error:', error);
      if (isMounted.current) {
        toast('Error deleting booking', { variant: 'error' });
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  // Search and query handlers
  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setInvestigationBookingDataObj({ loading: true, data: [] });

    try {
      const response = await axios.get(`${BASE_URL}/investigation-booking/list?limit=100`);
      if (isMounted.current && response.data?.success) {
        const filteredData = (response.data.data || [])
          .filter(item => item.status === 'active' || item.status === 'inactive' || item.status === 'default')
          .sort((a, b) => (b.bill_no || 0) - (a.bill_no || 0));

        setInvestigationBookingDataObj({ loading: false, data: filteredData });
      } else if (isMounted.current) {
        toast('Error in fetching data', { variant: 'error' });
        setInvestigationBookingDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Query error:', error);
      if (isMounted.current) {
        toast('Error fetching data', { variant: 'error' });
        setInvestigationBookingDataObj({ loading: false, data: [] });
      }
    }
  };

  const searchPatientHandler = async (uhid = null) => {
    if (!isMounted.current) return;

    setLoading(true);
    try {
      if (!uhid) {
        setSearchPatientRegisterationDialog(true);

        // Fetch all patients when opening the dialog
        const response = await request('/patient-registeration-search', {
          method: 'GET',
          query: { limit: 100 }
        });

        if (isMounted.current && response?.success) {
          const sortedPatientData = (response.data || [])
            .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
          setPatientDetailList(sortedPatientData);
          setOriginalOpdData(sortedPatientData);
        }
        return;
      }

      // Search by UHID
      const response = await request('/patient-registeration-search', {
        method: 'GET',
        query: { uhid }
      });

      if (isMounted.current && response?.success) {
        const patientData = response.data || [];

        if (patientData.length > 0) {
          const latestPatient = patientData[0];
          setPatientType('OPD');

          // Set form values
          setValue('uhid', latestPatient.uhid || '');
          setValue('patient_name', `${latestPatient.first_name || ''} ${latestPatient.last_name || ''}`.trim());
          setValue('patient_suffix', latestPatient.name_suffix || 'Mr.');
          setValue('mobile', latestPatient.address?.mobile || '');
          setValue('gender', latestPatient.gender || 'Male');
          setValue('address', latestPatient.address?.address || '');
          setValue('doctor', latestPatient.consultant?._id || '');
          setValue('ref_by', latestPatient.ref_by?._id || '');
          setValue('sponsor', latestPatient.sponsor?._id || '');
          setValue('guardian_name', latestPatient.guardian_name || '');
          setValue('guardian_type', latestPatient.guardian_type?._id || '');
          setValue('remarks', latestPatient.remarks || '');

          // Set age from DOB
          if (latestPatient.dob) {
            const preciseAge = AgeCalculator.calculatePreciseAge(latestPatient.dob);
            setValue('age', preciseAge?.displayText || '');
            setValue('age_in_days', preciseAge?.totalDays || 0);
          }

          toast('Patient details loaded successfully', { variant: 'success' });
        } else {
          toast('No patient found with this UHID', { variant: 'warning' });
        }
      } else if (isMounted.current) {
        toast('Failed to load patient details', { variant: 'error' });
      }
    } catch (error) {
      console.error('Search patient error:', error);
      if (isMounted.current) {
        toast('Error searching patient', { variant: 'error' });
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  const searchIPDDetails = async (ipd_no) => {
    if (!isMounted.current) return;

    setLoading(true);
    try {
      const response = await request('/indoor-registeration-detail', {
        method: 'GET',
        params: ipd_no
      });

      if (isMounted.current && response?.success && response.data) {
        const patientData = response.data;
        setPatientType('IPD');

        setValue('ipd_no', ipd_no);
        setValue('patient_name', `${patientData.patient?.first_name || ''} ${patientData.patient?.last_name || ''}`.trim());
        setValue('patient_suffix', patientData.patient?.name_suffix || 'Mr.');
        setValue('ward', patientData.consultant_detail?.room?.ward?.name || '');
        setValue('uhid', patientData.uhid || '');
        doctorIDRef.current = patientData.patient?.consultant?._id;
        setValue('doctor', patientData.patient?.consultant?._id || '');
        setValue('guardian_name', patientData.patient?.guardian_name || '');
        setValue('guardian_type', patientData.patient?.guardian_type || '');
        setValue('room_no', patientData.consultant_detail?.room?.room_no || '');
        setValue('bed_no', patientData.consultant_detail?.bed_no || '');
        setValue('sponsor', patientData.patient?.sponsor?._id || '');
        sponsorIdRef.current = patientData.patient?.sponsor?._id;
        setValue('address', patientData.patient?.address?.address || '');
        setValue('country', patientData.patient?.address?.country || '');
        setValue('state', patientData.patient?.address?.state || '');
        setValue('city', patientData.patient?.address?.city || '');
        setValue('aadhar', patientData.patient?.address?.aadhar || '');
        setValue('mobile', patientData.patient?.address?.mobile || '');
        setValue('email', patientData.patient?.address?.email || '');
        setValue('gender', patientData.patient?.gender || 'Male');
        setValue('ref_by', patientData.patient?.ref_by?.refferal_name?._id || '');

        if (patientData.patient?.dob) {
          const preciseAge = AgeCalculator.calculatePreciseAge(patientData.patient.dob);
          setValue('age', preciseAge?.displayText || '');
          setValue('age_in_days', preciseAge?.totalDays || 0);
        }
      } else if (isMounted.current) {
        toast('No IPD record found', { variant: 'warning' });
      }
    } catch (error) {
      console.error('Search IPD error:', error);
      if (isMounted.current) {
        toast('Failed to load IPD details', { variant: 'error' });
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  // Dropdown fetchers
  const getGuardianDropdown = useCallback(async () => {
    if (!isMounted.current) return;

    try {
      const data = await dropdownFetch('relation-master');
      if (isMounted.current) {
        setGuardianDropdown(data || []);
        if (!selectedRecord) {
          const defaultState = data.find(({ status }) => status === 'default');
          if (defaultState) {
            setValue('guardian_type', defaultState._id);
          }
        }
      }
    } catch (error) {
      console.error('Failed to fetch guardian dropdown:', error);
    }
  }, [selectedRecord, setValue]);

  const getSponsorDropdown = useCallback(async () => {
    if (!isMounted.current) return;

    try {
      const data = await dropdownFetch('sponsor');
      if (isMounted.current) {
        setSponsorDropdown(data || []);
        if (!selectedRecord) {
          const defaultSponsor = data.find(({ status }) => status === 'default');
          if (defaultSponsor) {
            setValue('sponsor', defaultSponsor._id);
          }
        }
      }
    } catch (error) {
      console.error('Failed to fetch sponsor dropdown:', error);
    }
  }, [selectedRecord, setValue]);

  const getReferralDropdown = useCallback(async () => {
    if (!isMounted.current) return;

    try {
      const data = await dropdownFetch('referral');
      if (isMounted.current) {
        setReferralDropdown(data || []);
        if (!selectedRecord) {
          const defaultReferral = data.find(({ status }) => status === 'default');
          if (defaultReferral) {
            setValue('ref_by', defaultReferral._id);
          }
        }
      }
    } catch (error) {
      console.error('Failed to fetch referral dropdown:', error);
    }
  }, [selectedRecord, setValue]);

  const getDoctorDropdown = useCallback(async () => {
    if (!isMounted.current) return;

    try {
      const data = await dropdownFetch('doctor');
      if (isMounted.current) {
        setDoctorDropdown(data || []);
        if (!selectedRecord && !getValues('consultant')) {
          const defaultState = data.find(({ status }) => status === 'default');
          if (defaultState) {
            setValue('consultant', defaultState._id);
            setValue('department', defaultState.qualification_details?.department || '');
          }
        }
      }
    } catch (error) {
      console.error('Failed to fetch doctor dropdown:', error);
    }
  }, [selectedRecord, getValues, setValue]);

  // Initialize dropdowns
  useEffect(() => {
    getGuardianDropdown();
    getSponsorDropdown();
    getReferralDropdown();
    getDoctorDropdown();
  }, [getGuardianDropdown, getSponsorDropdown, getReferralDropdown, getDoctorDropdown]);

  // Search handlers for OPD and IPD
  const handlefetchOpdBilling = async () => {
    setSearchOpdBillingDialog(true);
    setOpdBillingDataObj({ loading: true, data: [] });

    try {
      const response = await request('/opd-billing-investigation-list', { method: 'GET' });
      if (isMounted.current && response.success) {
        const filteredData = (response.data || [])
          .map((item) => {
            const filteredServiceItems = (item.service_items || []).filter((service) => service.type === 'L');
            return filteredServiceItems.length > 0 ? { ...item, service_items: filteredServiceItems } : null;
          })
          .filter((item) => item !== null)
          .filter((item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default')
          .sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));

        setOpdBillingDataObj({ loading: false, data: filteredData });
      } else if (isMounted.current) {
        toast('Error in fetching OPD billing data', { variant: 'error' });
        setOpdBillingDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('OPD billing fetch error:', error);
      if (isMounted.current) {
        toast('Error fetching OPD billing data', { variant: 'error' });
        setOpdBillingDataObj({ loading: false, data: [] });
      }
    }
  };

  const handlefetchIpdBilling = async () => {
    setSearchIpdBillingDialog(true);
    setIpdBillingDataObj({ loading: true, data: [] });

    try {
      const response = await request('/ipd-billing-investigation-list', { method: 'GET' });
      if (isMounted.current && response.success) {
        const filteredData = (response.data || [])
          .map((item) => {
            const filteredServiceItems = (item.service_items || []).filter((service) => service.type === 'L');
            return filteredServiceItems.length > 0 ? { ...item, service_items: filteredServiceItems } : null;
          })
          .filter((item) => item !== null)
          .filter((item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default')
          .sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));

        setIpdBillingDataObj({ loading: false, data: filteredData });
      } else if (isMounted.current) {
        toast('Error in fetching IPD billing data', { variant: 'error' });
        setIpdBillingDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('IPD billing fetch error:', error);
      if (isMounted.current) {
        toast('Error fetching IPD billing data', { variant: 'error' });
        setIpdBillingDataObj({ loading: false, data: [] });
      }
    }
  };

  // Search handlers with debouncing
  useEffect(() => {
    if (!isMounted.current) return;

    const timeoutId = setTimeout(() => {
      if (input.trim()) {
        handleUhidSearch(input);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [input]);

  const handleUhidSearch = async (searchTerm) => {
    if (!isMounted.current) return;

    try {
      const response = await request('/investigation-booking-list', {
        method: 'GET',
        query: { patient_name: searchTerm.toLowerCase().trim() }
      });

      if (isMounted.current && response.success && Array.isArray(response.data)) {
        setInvestigationBookingDataObj({ loading: false, data: response.data });
      } else if (isMounted.current) {
        setInvestigationBookingDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Search error:', error);
      if (isMounted.current) {
        setInvestigationBookingDataObj({ loading: false, data: [] });
      }
    }
  };

  const handleChange = (e) => {
    setInput(e.target.value);
  };

  const handleOpdChange = (e) => {
    setOpdInput(e.target.value);
  };

  // Age change handler
  const handleAgeChange = (ageValue) => {
    if (!ageValue) {
      setValue('age_in_days', 0);
      return;
    }

    const ageInDays = AgeCalculator.parseAgeToDays(ageValue);
    setValue('age_in_days', ageInDays);
  };

  // Reset form handler
  const handleResetForm = () => {
    setSelectedRecord(null);
    setCurrentAction('new');
    setPatientDetailList([]);
    setDetailList([]);
    setPatientType('walkin');
    setEditData(null);
    setIsEditMode(false);
    setEditingRowIndex(null);

    // Reset form with Lab mode as default
    reset({
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      patient_suffix: 'Mr.',
      gender: 'Male',
      age: '',
      age_in_days: 0,
      booking_mode: 'Lab',
      doctor: '',
      bill: {
        pay_mode: 'CASH',
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0,
        total_qty: 0,
        total_amt: 0,
        total_recpt: 0,
        balance_amt: 0
      },
      discountType: 'amount'
    });
  };

  // Field enabling logic
  const isFieldEditable = (uhid || ipd_no) ? false : ['new', 'edit'].includes(currentAction);
  const isDoctorRequired = bookingModeWatch !== 'Lab';

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Investigation Booking
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={handleResetForm}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  {loading ? 'Saving...' : 'Save'}
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={handleCancelRecord}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => selectedRecord && window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => setCurrentAction('')}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Booking Mode</Typography>
                    <SelectTag
                      formControlSX={{ flex: 1 }}
                      name="booking_mode"
                      disabled={!['new'].includes(currentAction)}
                      menus={LAB_BOOKING_TYPE}
                      onChange={(e) => handleBookingModeChange(e.target.value)}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>UHID /IPD No.</Typography>
                    <TextField disabled={true} sx={{ flex: 0.3 }} name="uhid" placeholder="Search by Uhid" />
                    <Button
                      disabled={!['new'].includes(currentAction) || bookingModeWatch !== 'Opd'}
                      sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                      variant="contained"
                      onClick={() => searchPatientHandler()}
                    >
                      <SearchIcon />
                    </Button>
                    <TextField disabled={true} sx={{ flex: 0.3 }} placeholder="Search Ipd No." name="ipd_no" />
                    <Button
                      disabled={!['new'].includes(currentAction) || bookingModeWatch !== 'Ipd'}
                      sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                      variant="contained"
                      onClick={() => setIPDSearchDialogOpen(true)}
                    >
                      <SearchIcon />
                    </Button>
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Gender/Age</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.4 }}
                      name="gender"
                      menus={GENDER_DROPDOWN}
                      disabled={!isFieldEditable}
                    />
                    <TextField
                      name="age"
                      sx={{ flex: 0.4 }}
                      disabled={!isFieldEditable}
                      onChange={(e) => handleAgeChange(e.target.value)}
                      placeholder="e.g., 25 years, 6 months, 2 days"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="sponsor"
                      disabled={!isFieldEditable}
                      menus={sponsorDropdown}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                    <TextField sx={{ flex: 0.8 }} name="remarks" disabled={!['new', 'edit'].includes(currentAction)} />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Barcode/Bill No</Typography>
                    <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="App No." name="barcode_no" />
                    <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="Bill No." name="bill_no" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                    <SelectTag
                      name="patient_suffix"
                      formControlSX={{ flex: 0.2 }}
                      disabled={!isFieldEditable}
                      menus={TITLES}
                    />
                    <TextField
                      name="patient_name"
                      sx={{ flex: 0.6 }}
                      disabled={!isFieldEditable}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Mobile No</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      name="mobile"
                      disabled={!isFieldEditable}
                      type="number"
                      error={!!formState.errors.mobile}
                      helperText={formState.errors.mobile?.message || ''}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doctor Name</Typography>
                    <SelectTag
                      menus={doctorDropdown}
                      formControlSX={{ flex: 0.8 }}
                      name="doctor"
                      disabled={!isFieldEditable}
                      required={isDoctorRequired}
                    />
                  </Stack> 
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}> Date/Time/Sno</Typography>
                    <TextField sx={{ flex: 0.3 }} name="date" type="date"  disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)} />
                    <TextField sx={{ flex: 0.3 }} name="time" type="time"  disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)} />
                    <TextField sx={{ flex: 0.2 }} name="s_no" disabled />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Guardian</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.2 }}
                      name="guardian_type"
                      disabled={!isFieldEditable}
                      menus={guardianDropdown}
                    />
                    <TextField
                      sx={{ flex: 0.6 }}
                      name="guardian_name"
                      disabled={!isFieldEditable}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Address</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      name="address"
                      disabled={!isFieldEditable}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Ref By</Typography>
                    <SelectTag
                      disabled={!isFieldEditable}
                      formControlSX={{ flex: 0.8 }}
                      name="ref_by"
                      menus={referralDropdown.map((data) => ({ ...data, name: data.referral_name }))}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Stack spacing={1} direction="row" justifyContent="space-between">
                    <Stack spacing={1} direction="row"></Stack>
                    <Button
                      variant="outlined"
                      disabled={!['new', 'edit'].includes(currentAction) || (isDoctorRequired && !watch('doctor'))}
                      onClick={() => {
                        setAddDetailsDialogOpen(true);
                        setIsEditMode(false);
                        setEditData(null);
                        setEditingRowIndex(null);
                      }}
                    >
                      Add Details
                    </Button>
                  </Stack>
                  <Table
                    containerSX={{ flex: 1, border: '0px solid grey' }}
                    data={detailList.map((data, index) => ({ _id: index, ...data }))}
                    columns={BILL_TABLE_HEADER}
                    size="small"
                    showEditButton={['new', 'edit'].includes(currentAction) && true}
                    handleDeleteRow={handleRowDelete}
                    showEditAction={true}
                    handleRowEdit={handleRowEdit}
                    onClickEditRow={handleRowEdit}
                  />
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Payment Mode</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="bill.pay_mode"
                      menus={RECEIPT_MODE}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Auth Code</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="bill.auth_code"
                      placeholder="Auth Code"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Qty/Amt</Typography>
                    <TextField disabled sx={{ flex: 0.3 }} name="bill.total_qty" placeholder="Qty" />
                    <TextField disabled sx={{ flex: 0.5 }} name="bill.total_amt" placeholder="Amt" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Discount</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction) || !watch('bill.pay_mode')}
                      formControlSX={{ flex: .3 }}
                      value={discountType}
                      onChange={(e) => {
                        setDiscountType(e.target.value);
                        // Reset discount value when switching type
                        setValue('bill.disc_amt', 0);
                      }}
                      menus={DISCOUNT_TYPES}
                      name="discountType"
                    />
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction) || !watch('bill.pay_mode')}
                      sx={{ flex: 0.5 }}
                      name="bill.disc_amt"
                      placeholder={discountType === 'percentage' ? 'Disc. %' : 'Disc. Amt'}
                      type="number"
                      inputProps={{
                        min: '0',
                        max: discountType === 'percentage' ? '100' : undefined
                      }}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Net Amt</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="bill.net_amt" placeholder="Net Amount" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>RecAmt 1&2</Typography>
                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      inputProps={{ min: '0' }}
                      name="bill.rec_amt_1"
                      placeholder="Amt 1"
                    />
                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      inputProps={{ min: '0' }}
                      name="bill.rec_amt_2"
                      placeholder="Amt 2"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Recpt.</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="bill.total_recpt" placeholder="Total" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Balance Amt</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="bill.balance_amt" placeholder="Balance Amount" />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>

      {/* Patient Search Dialog */}
      <Dialog
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        open={searchPatientRegisterationDialog}
        onClose={() => setSearchPatientRegisterationDialog(false)}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Patient Query Window
          </Typography>
          <IconButton onClick={() => setSearchPatientRegisterationDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem'
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={opdInput}
            onChange={handleOpdChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={PATIENT_TABLE_HEADER}
          data={patientDetailList}
          onRowClick={(row) => {
            setBookingId(row?._id);
            setValue('uhid', row.uhid);
            setValue('patient_name', `${row.first_name || ''} ${row.last_name || ''}`.trim());
            setValue('patient_suffix', row.name_suffix || 'Mr.');
            setValue('mobile', row.address?.mobile || '');
            setValue('gender', row.gender || 'Male');
            setValue('address', row.address?.address || '');
            setValue('doctor', row.consultant?._id || '');
            setValue('ref_by', row.ref_by?._id || '');
            setValue('sponsor', row.sponsor?._id || '');
            setValue('guardian_name', row.guardian_name || '');
            setValue('guardian_type', row.guardian_type?._id || '');
            setValue('remarks', row.remarks || '');

            if (row.dob) {
              const preciseAge = AgeCalculator.calculatePreciseAge(row.dob);
              setValue('age', preciseAge?.displayText || '');
              setValue('age_in_days', preciseAge?.totalDays || 0);
            }

            setPatientType('OPD');
            setSearchPatientRegisterationDialog(false);
          }}
        />
      </Dialog>

      {/* OPD Billing Dialog */}
      <Dialog
        PaperProps={{ sx: { width: '80%', p: 1 } }}
        open={searchOpdBillingDialog}
        onClose={() => setSearchOpdBillingDialog(false)}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={1.5}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            OPD Billing Tests
          </Typography>
          <IconButton onClick={() => setSearchOpdBillingDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 3 }}
          columns={OPD_BILLING_TABLE_HEADER}
          data={opdBillingDataObj.data}
          loading={opdBillingDataObj.loading}
          onRowClick={(row) => {
            setBookingId(row?._id);
            setValue('uhid', row.uhid);
            setValue('patient_name', `${row.patient?.name || ''}`.trim());
            setValue('patient_suffix', row.name_suffix || 'Mr.');
            setValue('mobile', row.patient?.mobile_no || '');
            setValue('gender', row.gender || 'Male');
            setValue('address', row.patient?.address || '');
            setValue('doctor', row.patient?.consultant || '');
            setValue('ref_by', row.patient?.ref_by || '');
            setValue('sponsor', row.patient?.sponsor || '');
            setValue('guardian_name', row.patient?.guardian_name || '');
            setValue('guardian_type', row.patient?.guardian_type || '');
            setValue('remarks', row.remarks || '');
            setPatientType('OPD');
            setSearchOpdBillingDialog(false);
            setDetailList(row.service_items || []);
          }}
        />
      </Dialog>

      {/* IPD Billing Dialog */}
      <Dialog
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        open={searchIpdBillingDialog}
        onClose={() => setSearchIpdBillingDialog(false)}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            IPD Billing Tests
          </Typography>
          <IconButton onClick={() => setSearchIpdBillingDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={IPD_BILLING_TABLE_HEADER}
          data={ipdBillingDataObj.data}
          loading={ipdBillingDataObj.loading}
          onRowClick={(row) => {
            setBookingId(row?._id);
            setValue('uhid', row.patient?.uhid);
            setValue('ipd_no', row.ipd_no);
            setValue('patient_name', `${row.patient?.name || ''}`.trim());
            setValue('patient_suffix', row.name_suffix || 'Mr.');
            setValue('mobile', row.patient?.mobile_no || '');
            setValue('gender', row.gender || 'Male');
            setValue('address', row.patient?.address || '');
            setValue('doctor', row.patient?.consultant || '');
            setValue('ref_by', row.patient?.ref_by || '');
            setValue('sponsor', row.patient?.sponsor || '');
            setValue('guardian_name', row.patient?.guardian_name || '');
            setValue('guardian_type', row.patient?.guardian_type || '');
            setValue('remarks', row.remarks || '');
            setPatientType('IPD');
            setSearchIpdBillingDialog(false);
            setDetailList(row.service_items || []);
          }}
        />
      </Dialog>

      {/* IPD Search Dialog */}
      <Dialog
        PaperProps={{ sx: { p: 1 } }}
        open={IPDSearchDialogOpen}
        onClose={() => setIPDSearchDialogOpen(false)}
        scroll="body"
        maxWidth="xl"
      >
        <IPDSearchHandler key={String(IPDSearchDialogOpen)} onClose={() => setIPDSearchDialogOpen(false)} onAdd={searchIPDDetails} />
      </Dialog>

      {/* Add Details Dialog */}
      <Dialog
        open={addDetailsDialogOpen}
        onClose={() => {
          setAddDetailsDialogOpen(false);
          setIsEditMode(false);
          setEditData(null);
          setEditingRowIndex(null);
        }}
        PaperProps={{ sx: { width: '60%', height: '80vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <LabBillingDetailform
          chargeType={patientType === 'IPD' ? 'ipd_charges' : 'opd_charges'}
          onClose={() => {
            setAddDetailsDialogOpen(false);
            setIsEditMode(false);
            setEditData(null);
            setEditingRowIndex(null);
          }}
          onAdd={onDetailAddHandler}
          sponsorId={sponsorIdRef?.current || sponsor}
          patientType={patientType}
          editData={editData}
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          setEditData={setEditData}
        />
      </Dialog>

      {/* Query Dialog */}
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Investigation Booking Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem'
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={investigationBookingDataObj.data}
          loading={investigationBookingDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};



